var $be521f3abe2a5b42$exports = {};
$be521f3abe2a5b42$exports = {
    "endTime": `\u{C885}\u{B8CC} \u{C2DC}\u{AC04}`,
    "startTime": `\u{C2DC}\u{C791} \u{C2DC}\u{AC04}`,
    "time": `\u{C2DC}\u{AC04}`
};


export {$be521f3abe2a5b42$exports as default};
//# sourceMappingURL=ko-KR.module.js.map
